import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ReactGA from 'react-ga4';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ModelsPage from './pages/ModelsPage'; // Ensure this path is correct
import GetStartedPage from './pages/GetStartedPage';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import InfoPage from './pages/info';
import WhatIsNumeraiTournament from './pages/info/what-is-the-numerai-tournament';
import ContactPage from './pages/ContactPage';

// Google Analytics Page Tracking Component
const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize('G-T0WZMDHCE2', { 
      debug: true,  // Enables console logging
      gaOptions: {
        siteSpeedSampleRate: 100  // Collect performance data for all pages
      }
    });
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return null;
};

const App = () => (
  <AuthProvider>
    <Router>
      <GoogleAnalytics />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/models" element={<ModelsPage />} /> {/* Ensure this is added */}
        <Route path="/get-started" element={<GetStartedPage />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/info" element={<InfoPage />} />
        <Route path="/info/what-is-the-numerai-tournament" element={<WhatIsNumeraiTournament />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>
  </AuthProvider>
);

export default App;
